import * as apiServices from "../../services/apiServices";
import setLoaderAction from "./loaderAction";
import * as toastAction from "../actions/toastAction";
import { DEFAULT_ERROR_MESSAGE, ERROR_TIMEOUT, TOKEN_KEY, PDF_DOWNLOAD, EXCEL_DOWNLOAD } from "../../App.config";

//export functions
export const onDownloadReportClick = (companyId, downloadFormat, fromDate, toDate, moduleId, reportId, levelNo, levelItemId, reportName, isLangEng) => (dispatch) => {
    dispatch(setLoaderAction(true));
    return apiServices
        .onDownloadReportClick(companyId, downloadFormat, fromDate, toDate, moduleId, reportId, levelNo, levelItemId, isLangEng)
        .then(({ data }) => {
            if (data.isTransactionSucceed) {
                dispatch(setLoaderAction(false));
                let dwOperation = PDF_DOWNLOAD == downloadFormat ? "data:application/pdf;base64," : "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
                let extension = PDF_DOWNLOAD == downloadFormat ? ".pdf" : ".xlsx";
                const linkSource = dwOperation + data.reportBase64Data;
                const downloadLink = document.createElement("a");
                const fileName = (reportName ? reportName : "report") + extension;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                if (data.errorMessage) {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, data.errorMessage));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                } else {
                    dispatch(setLoaderAction(false));
                    dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
                    setTimeout(() => {
                        dispatch(toastAction.showErrorMessage(false, ""));
                    }, ERROR_TIMEOUT);
                }
            }
        })
        .catch((error) => {
            dispatch(setLoaderAction(false));
            dispatch(toastAction.showErrorMessage(true, DEFAULT_ERROR_MESSAGE));
            setTimeout(() => {
                dispatch(toastAction.showErrorMessage(false, ""));
            }, ERROR_TIMEOUT);
        });
};
